<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
        :visible.sync="dialogVisible"
        :width="DialogWidth"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:50%;margin-left:5%;" v-if="switchover == true">
          <el-form :label-position="labelPosition" label-width="120px" :model="result" style="width:75%;">
              <el-form-item label="系统配置名" >
                <el-input v-model="result.appName" size="small" ></el-input>
              </el-form-item>
              <el-form-item label="上级code" >
                <el-input v-model="result.appCode" type="text" size="small" ></el-input>
              </el-form-item>
              <el-form-item label="有效期" >
                <el-date-picker
                v-model="effective"
                type="date"
                @change="inDateTime()"
                placeholder="选择日期"
                :picker-options="pickerOptions">
                </el-date-picker>
               </el-form-item>
                <el-form-item label="备注" >
                    <el-input v-model="result.remarks" size="small"></el-input>
                </el-form-item>
            </el-form>        
        </div>
        <div style="width:50%;margin-left:5%;" v-else>
          <el-form :label-position="labelPosition" label-width="120px" :model="result" style="width:75%;">
              <el-form-item label="系统配置名" >
                <el-input v-model="result.appName" size="small" ></el-input>
              </el-form-item>
              <el-form-item label="有效期" >
                <el-date-picker
                v-model="effective"
                type="date"
                @change="inDateTime()"
                placeholder="选择日期"
                :picker-options="pickerOptions">
                </el-date-picker>
               </el-form-item>
                <el-form-item label="备注" >
                    <el-input v-model="result.remarks" size="small"></el-input>
                </el-form-item>
            </el-form>        
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SystemConfigDialog",
  data() {
    return {
    dialogVisible: false,
    title:"标题",
    labelPosition:'right',
    result:{},
    appCode:"",
    effective:"",
    DialogWidth:"50%",
    switchover:true,
    effectiveDate:"",
        pickerOptions: {
            disabledDate(time) {
            return time.getTime() < Date.now();
            },
        },
    };
  },
  watch:{
        dialogVisible(val){

        }
  },
  methods: {
    ChargeBillType(){

    },
    modification(){
        if(this.title.indexOf("修改") != -1){
            if(typeof(this.effective) == "string"){
                let obj = {
                    "appName":this.result.appName,
                    "appIdentifier":this.result.appIdentifier,
                    "effectiveDate":this.effective,
                    "remarks":this.result.remarks
                }
                if(obj.appName== undefined || obj.appName == null){
                        this.$message({ type: "warning", message: "请填写系统配置名" })
                }else if(obj.effectiveDate== undefined || obj.effectiveDate == null){
                        this.$message({ type: "warning", message: "请选择有效期" })
                }else{
                    this.Putup(obj)
                }
            }else{
                let obj = {
                    "appName":this.result.appName,
                    "appIdentifier":this.result.appIdentifier,
                    "effectiveDate":this.effectiveDate,
                    "remarks":this.result.remarks
                } 
                if(obj.appName== undefined || obj.appName == null){
                        this.$message({ type: "warning", message: "请填写系统配置名" })
                }else if(obj.effectiveDate== undefined || obj.effectiveDate == null){
                        this.$message({ type: "warning", message: "请选择有效期" })
                }else{
                    this.Putup(obj)
                }
            }
        }else{
        let obj = {
            "appName":this.result.appName,
            "appCode":this.result.appCode,
            "effectiveDate":this.effectiveDate,
            "remarks":this.result.remarks
        }
            if(obj.appName== undefined || obj.appName == null){
                    this.$message({ type: "warning", message: "请填写系统配置名" })
            }else if(obj.effectiveDate== undefined || obj.effectiveDate == null){
                    this.$message({ type: "warning", message: "请选择有效期" })
            }else if(obj.remarks== undefined || obj.remarks == null){
                    this.$message({ type: "warning", message: "请填写备注"})
            }else{
                this.$http.post(this.$requestUrl.POST_SYS_CONFIG_ADD,obj).then((res) => {
                    let result = res.data;
                    if (200 === result.code) {
                        this.dialogVisible = false
                        this.$emit("Visible",false)
                        this.$message({ type: 'success', message: '添加成功!' });
                    } else {
                        this.$message.error(result.msg)
                    }
                }).catch(() => {
                    this.$message.error(this.$errorMessage.SEVER_ERROR)
                }) 
            }
        }
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    inDateTime(){
      this.effectiveDate = this.filterTime(this.effective)

    },
    Putup(obj){
        this.$http.put(this.$requestUrl.PUT_SYS_CONFIG_UP,obj).then((res) => {
            let result = res.data;
            if (200 === result.code) {
                this.dialogVisible = false
                this.$emit("Visible",false)
                this.$message({ type: 'success', message: '修改成功!' });
            } else {
                this.$message.error(result.msg)
            }
        }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
        }) 
    },
    filterTime(time) {
        var date = new Date(time);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var h = date.getHours();
        h = h < 10 ? "0" + h : h;
        var minute = date.getMinutes();
        minute = minute < 10 ? "0" + minute : minute;
        var s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + m + "-" + d;
    },
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {

       
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>